import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { CustomizeBrandingService } from './customize-branding.service';
import { VideoLibraryService } from '../video-library.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { AddLogoComponent } from './add-logo/add-logo.component';
import { BannerComponent } from './banner/banner.component';
import { CategoryDisplayNameComponent } from './category-display-name/category-display-name.component';
@Component({
  selector: 'app-customize-branding',
  templateUrl: './customize-branding.component.html',
  styleUrls: ['./customize-branding.component.scss'],
})
export class CustomizeBrandingComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  activatedComponentRef: any;
  selectionInfo: SelectionInfo;
  active: number;
  sub = new Subscription();
  supportedConsoles = ['superman','hal','mulder'];
  currentFacility: FacilityObject;
  hasFullPermission: boolean = false;
  activatedRouteUrl:string;
  showError = false;
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private commonUtil: CommonUtil,
    private _customizeBrandingService: CustomizeBrandingService,
    private _vdoLibraryService: VideoLibraryService,
    private _loader: HaloLoaderService
  ) {
    const routeChangeSub = this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url) {
          this.activatedRouteUrl = event.url;
          this.updateShowErrorStatus();
        }
      }
    });

    this.sub.add(routeChangeSub);

  }

  ngOnInit(): void {
    this._setDefaultTab();
    this._trackingChangingRoutes();
    this.rootScopeData = this.commonUtil.rootScopeData;
    this.currentFacility = this._facilityService.selectedFacility();    
    this.prepareView();
    const facilityChanges = this._facilityService.selectedFacilitySource.subscribe((val) => {
      this.currentFacility = val;
      this.prepareView();
    });
    this.sub.add(facilityChanges);
  }

  private async prepareView() {
    if(!this.currentFacility?.summary) return;
    const isEligibleLFODFacilityRight = this.currentFacility.summary.facilityRights.customLibrary === 'true' ? true : false;
      const hasViewPermission = this.currentFacility.summary.userRights.customLibrary !== "H";
      if (!isEligibleLFODFacilityRight || !hasViewPermission) {
        this.commonUtil.redirectToAvailablePage();
      } else {
        this._loader.startProcess();
        this.updateEquipmentEnabled();
        await this._customizeBrandingService.getCustomize(this._facilityService.selectedFacility().facilityId);
        this._loader.endProcess();
      }
      this.hasFullPermission = this.currentFacility.summary.userRights.customLibrary === 'F' || this.currentFacility.summary.isLoggedInManagerAdmin === 'true';
      this.activatedComponentRef?.onPermissionChange(this.hasFullPermission);
  }

  navigateToChild(childPath: string): void {
    if (this.rootScopeData.isPageHasUnsavedChanges && !this._router.routerState.snapshot.url.includes(childPath)) {
      this.rootScopeData.pathToNavigate = childPath;
      this.rootScopeData.showUnSavedChangesModal = true;
      setTimeout(() => {
        this._setDefaultTab();
      });
    } else {
      this._router.navigate([childPath], { relativeTo: this._activatedRoute });
    }
  }

  enable(): void {
    this._router.navigate(['/enable_equipment']);
  }

  private _trackingChangingRoutes(): void {
    const routes = this._router.events.subscribe((val: any) => {
      if (val.url?.includes('addLogo')) {
        this.active = 1;
      }
      if (val.url?.includes('banner')) {
        this.active = 2;
      }
      if (val.url?.includes('categoryDisplayName')) {
        this.active = 3;
      }
    });
    this.sub.add(routes);
  }

  private async updateEquipmentEnabled() {
    try {
      let data:any;
      let tmp_1 = await this._vdoLibraryService.getEnabledOnDemandClasses([Number(this._facilityService.selectedFacilityId())]).toPromise() as [];
      let tmp_2 = Object.values(tmp_1)[0] as any;
      let se4ConsolesTypes = ['hal','everest','neo_se4','falco'];
      if(JSON.stringify(tmp_2) === "{}"){
        data = [];
      }else{
        let tmp_3 = Object.values(tmp_2);
        let enableLFODEquipments = [] as any;
        tmp_3.forEach((ele:any) => {
          enableLFODEquipments.push({
            "customLibraryEnabledCount":ele.customLibraryEnabledCount,
            "lfodenabledCount":ele.lfodenabledCount,
            "consoleType":ele.consoleType
          })
        });
        data = enableLFODEquipments;
      }
      if(data.length>0){
        this._customizeBrandingService.isLFODEnabledCount =  data.find((val:any) => val.lfodenabledCount>0)?true:false;
        this._customizeBrandingService.isSe4LFODEnabledCount = data.find((val:any) => se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false;
        this._customizeBrandingService.isSe3LFODEnabledCount = data.find((val:any) => !se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false;
        this._customizeBrandingService.isCustomLibraryEnabledCount = data.find((val:any) => val.customLibraryEnabledCount>0)?true:false;
      }else{
        this._customizeBrandingService.isLFODEnabledCount = false;
        this._customizeBrandingService.isSe4LFODEnabledCount = false;
        this._customizeBrandingService.isSe3LFODEnabledCount = false;
        this._customizeBrandingService.isCustomLibraryEnabledCount = false;
      }
      this._customizeBrandingService.triggerEnableStatus();
    } catch (error) {
      this._customizeBrandingService.isLFODEnabledCount = false;
      this._customizeBrandingService.isSe4LFODEnabledCount = false;
        this._customizeBrandingService.isSe3LFODEnabledCount = false;
      this._customizeBrandingService.isCustomLibraryEnabledCount = false;
      console.error('API error');
    }
    this.updateShowErrorStatus();
  }

  updateShowErrorStatus(){
    if(this.activatedRouteUrl){
      if(this.activatedRouteUrl.includes("addLogo") || this.activatedRouteUrl.includes("banner")) {
        this.showError = !this._customizeBrandingService.isLFODEnabledCount;
      }
      else if(this.activatedRouteUrl.includes("categoryDisplayName")){
        this.showError = !this._customizeBrandingService.isCustomLibraryEnabledCount;
      }
    }
  }

  private _setDefaultTab(): void {
    if (this._router.routerState.snapshot.url.includes('addLogo')) {
      this.active = 1;
    } else if (this._router.routerState.snapshot.url.includes('banner')) {
      this.active = 2;
    } else {
      this.active = 3;
    }
  }
  private onComponentActivated(componentRef: any) {
    if(componentRef instanceof AddLogoComponent || componentRef instanceof BannerComponent || componentRef instanceof CategoryDisplayNameComponent) {
      this.activatedComponentRef = componentRef;
      componentRef.onPermissionChange(this.hasFullPermission);
    }
  }


  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this._loader.endProcess();
  }
}
